var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('span',{staticClass:"assistant-feedback"},[_c('div',{staticClass:"text-feedback"},[_vm._v("若无法发送好友申请，将异常提示截图到公众号，客服将处理")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }